import React, { useCallback, useEffect, useMemo, useState } from 'react';
import avatar from '../../../assets/img/candidate-avatars-lg.png';
import PageLoader from '../../../components/loader';
import Table from '../../../components/table';
import { SortTypeEnum } from '../../../types';
import { candidateService } from '../../../lib/api/candidate';
import {
    CandidateStatus,
    DataPunchStatus,
    MatchesEnum,
    MatchListRequestType,
    MatchListType,
    MatchRequestType,
} from '../../../types/candidate';

const NoMatchTable = () => {
    const [data, setData] = useState<MatchListType[]>([]);
    const [loading, setLoading] = useState(true);

    const candidateStatus = (candidateStatusValue: CandidateStatus) => {
        switch (candidateStatusValue) {
            case CandidateStatus.Joined:
                return 'Joined';
            case CandidateStatus.Joined:
                return 'Joined';
            case CandidateStatus.Uploaded:
                return 'Uploaded';
            case CandidateStatus.Pending:
                return 'Pending';
            case CandidateStatus.Deleted:
                return 'Deleted';
            case CandidateStatus.Invited:
                return 'Invited';
            case CandidateStatus.ProvisionallyJoined:
                return 'Provisionally Joined';
            default:
                return 'NA';
                break;
        }
    };

    const dataPunchStatus = (dataPunchStatusValue: DataPunchStatus) => {
        switch (dataPunchStatusValue) {
            case DataPunchStatus.InReview:
                return 'In Review';
            case DataPunchStatus.Pending:
                return 'Pending';
            case DataPunchStatus.InReview:
                return 'In Review';
            case DataPunchStatus.MatchConfirmed:
                return 'Match Confirmed';
            case DataPunchStatus.MatchRejected:
                return 'Match Rejected';
            case DataPunchStatus.Completed:
                return 'Completed';
            case DataPunchStatus.Failed:
                return 'Failed';
            case DataPunchStatus.NoActivity:
                return 'No Activity';
            default:
                return 'NA';
        }
    };

    const columns = useMemo(
        () => [
            {
                dataIndex: 'candidateName',
                title: 'Candidate Name',
                render: (item: any) => (
                    <>
                        <div className="d-flex cursor-pointer">
                            <div className="offer-table-reoffered me-2">
                                <img src={item.avatarUrl || avatar} alt="" className="avatar avatar--xs" />
                            </div>
                            <div className="text-crop" style={{ top: '6px' }}>
                                <a className="big-text text-capitalize offer-table-link" title={item.candidateName}>
                                    {item.candidateName}
                                </a>
                            </div>
                        </div>
                    </>
                ),
            },
            {
                dataIndex: 'candidateStatus',
                title: 'Candidate Joining Status',
                render: (item: any) => (
                    <>
                        <div className="text-ellipsis text-capitalize">
                            <span>{candidateStatus(item.candidateStatus)}</span>
                        </div>
                    </>
                ),
            },
            {
                dataIndex: 'dataPunchStatus',
                title: 'DataPunch Status',
                render: (item: any) => (
                    <>
                        <div className="text-ellipsis text-capitalize">
                            <span>{dataPunchStatus(item.dataPunchStatus)}</span>
                        </div>
                    </>
                ),
            },
            {
                dataIndex: 'punchedByCompany',
                title: 'Punched By',
                render: (item: any) => (
                    <>
                        <div className="text-ellipsis">
                            <span>{item.punchedByCompany || 'NA'}</span>
                        </div>
                    </>
                ),
            },
            {
                dataIndex: 'dataPunchDate',
                title: 'Punch Date',
                width: '128px',
                inputFilter: (value: any) => {
                    return new Date(value).toLocaleString('en-in', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric',
                    });
                },
                render: (item: any) =>
                    new Date(item.dataPunchDate).toLocaleString('en-in', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric',
                    }),
            },
        ],
        [],
    );

    const getList = useCallback(async () => {
        try {
            sessionStorage.clear();
            !loading && setLoading(true);
            const params: MatchRequestType = {
                matchType: MatchesEnum.MisMatch,
            };

            const { resultObject } = await candidateService.getMatchList(params);
            setData(resultObject);
        } catch (err) {
        } finally {
            setLoading(false);
        }
    }, [loading]);

    useEffect(() => {
        (async function () {
            await getList();
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <h1 className="">No Matches</h1>
                </div>
            </div>
            <div className="company-page-contener employer-table">
                {loading ? (
                    <PageLoader />
                ) : (
                    <>
                        <Table columns={columns} data={data} />
                    </>
                )}
            </div>
        </>
    );
};

export default NoMatchTable;
